import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default defineNuxtPlugin(async () => {
    const visitorId = useState('visitorId', () => null)

    try {
        const fp = await FingerprintJS.load()
        const result = await fp.get()
        visitorId.value = result.visitorId
    } catch (error) {
        console.error('Failed to get visitor fingerprint', error)
    }
})
